import { render, staticRenderFns } from "./ProjectNavbar.vue?vue&type=template&id=6b60d550&scoped=true&"
import script from "./ProjectNavbar.vue?vue&type=script&lang=js&"
export * from "./ProjectNavbar.vue?vue&type=script&lang=js&"
import style0 from "./ProjectNavbar.vue?vue&type=style&index=0&id=6b60d550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b60d550",
  null
  
)

export default component.exports